import * as globalActions from "../actions/global/actions";

type SetLargeScreenType = (dispatch: any, data: boolean) => void;

export const setLargeScreen: SetLargeScreenType = (dispatch, data) =>
  dispatch(globalActions.setLargeScreen({ largeScreen: data }));
